import { render, staticRenderFns } from "./gamelobby.vue?vue&type=template&id=3c395d32&scoped=true"
import script from "./gamelobby.vue?vue&type=script&lang=js"
export * from "./gamelobby.vue?vue&type=script&lang=js"
import style0 from "./gamelobby.vue?vue&type=style&index=0&id=3c395d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c395d32",
  null
  
)

export default component.exports